<script setup lang="ts">
  import { Text } from "@ui-kit";
  import { StatusBar } from "@src/components";

  const { title, subtitle } = defineProps<{ title: string; subtitle: string }>();
</script>

<template>
  <div class="alarming" data-testid="alarming-write">
    <StatusBar />
    <div class="alarming__content">
      <slot name="icon" />
      <Text class="alarming__title" font="heading-H4" v-html="title" />
      <Text class="alarming__subtitle" color="secondary">{{ subtitle }}</Text>
    </div>
    <div class="alarming__buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<style scoped>
  .alarming {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    justify-content: space-between;
    background-color: var(--sf-base-background-primary);
  }

  .alarming__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    white-space: break-spaces;
    padding: 0 16px;
  }

  .alarming__title {
    margin-top: 24px;
  }

  .alarming__subtitle {
    margin-top: 8px;
  }

  .alarming__buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 16px 20px;
  }

  .alarming__buttons :slotted(button) {
    width: 100%;
  }
</style>
